var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrofeu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFD54A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 20h60v18a18 18 0 0 1-18 18H48a18 18 0 0 1-18-18V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 78h30v6a6 6 0 0 1-6 6H51a6 6 0 0 1-6-6v-6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#B8860B"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 90,
    width: 20,
    height: 6,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofeu);
export default __webpack_public_path__ + "static/media/trofeu.6b26c7d97c0f76d7059a50d624313d33.svg";
export { ForwardRef as ReactComponent };